import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

/**
 * 내 비밀번호 변경
 * @endpoint PUT /auth/password
 */
export function putMePasswordApi(body: ChangePasswordRequest) {
  return axiosInstance.put<ApiResponse<null>>('/auth/password', body);
}
